import { render } from "./NavigationBar.vue?vue&type=template&id=05e4315a&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=05e4315a&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e4315a"]])

export default __exports__